import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/kanliao";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/90 backdrop-blur-md shadow-soft border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <nav className="container-px flex h-16 md:h-[72px] items-center justify-between gap-4">
        <a href="#home" className="flex items-center gap-2 whitespace-nowrap">
          <span
            className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50"
            aria-hidden="true"
          >
            <i className="ri-flashlight-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl font-bold ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            看料
          </span>
        </a>

        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  scrolled
                    ? "text-foreground-700 hover:bg-secondary-100 hover:text-foreground-950"
                    : "text-white/90 hover:bg-white/15 hover:text-white"
                }`}
              >
                <i className={`${link.icon} text-base`} aria-hidden="true"></i>
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            立即订阅
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            className="flex h-10 w-10 items-center justify-center rounded-lg md:hidden"
            style={{
              color: scrolled || open ? "var(--foreground-950)" : "#fff",
            }}
          >
            <i
              className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}
            ></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 backdrop-blur-md md:hidden">
          <ul className="container-px flex flex-col gap-1 py-4">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-3 rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
                >
                  <i
                    className={`${link.icon} text-lg text-primary-600`}
                    aria-hidden="true"
                  ></i>
                  {link.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center rounded-full bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50"
              >
                立即订阅
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}